import { EventHelper } from "app/helpers/eventHelper";
import AsianOdds from "app/screens/AsianEventsScreen/components/AsianOdds/AsianOdds";
import type {
  EventMarketPeriodType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import get from "lodash/get";
import React from "react";
import "./AsianEventCellTotalOddEven.scss";

const AsianEventCellTotalOddEven = (
  props: Record<string, any>
): React.JSX.Element => {
  const { marketPeriods, event, addBetSlip } = props;
  // Each market period will have one "odd" and one "even" runner
  const runnerDictionary = {};
  marketPeriods.forEach((mp, index) => {
    const marketPeriodName = mp.marketPeriod.toLowerCase();
    const market = get(mp, ["marketTypes", [0], "markets", [0]]);
    market.runners.forEach(runner => {
      const runnerType = runner.type.toLowerCase();
      const oddsComponent = getRunnerOddsComponent(
        market,
        marketPeriods,
        event,
        addBetSlip,
        props,
        runner
      );
      runnerDictionary[marketPeriodName + "__" + runnerType] = oddsComponent;
    });
  });
  return (
    <React.Fragment>
      <div className="asian-total-odd-even-runners">
        {runnerDictionary["full_event__odd"]}
        {runnerDictionary["full_event__even"]}
      </div>

      <div className="asian-total-odd-even-runners">
        {runnerDictionary["first_half__odd"]}
        {runnerDictionary["first_half__even"]}
      </div>
    </React.Fragment>
  );
};

export default AsianEventCellTotalOddEven;

const getRunnerOddsComponent = (
  market: Record<string, any>,
  marketPeriods: EventMarketPeriodType[],
  event: EventType,
  addBetSlip: (...args: Array<any>) => any,
  props: Record<string, any>,
  runner: EventRunnerType
) => {
  if (
    !runner ||
    !runner["aggregatedPrices"] ||
    (runner["aggregatedPrices"] && runner["aggregatedPrices"].length === 0)
  ) {
    return <div className="asian-odds-empty--small"></div>;
  }

  const highestOdds = EventHelper.getHighestOddsValueFrom(
    runner["aggregatedPrices"]
  );
  return (
    <div className={`asian-total-odd-even-runner`}>
      <AsianOdds
        className={`${event["inRunning"] ? "asian-odds-live" : ""}`}
        odds={highestOdds}
        onClickPrice={() => addBetSlip(runner, props, event)}
        runner={runner}
      />
    </div>
  );
};
